import React, { useEffect, useRef, useState } from 'react';
import App from '@app';
import { Body, PageHeader, FormCadastro, Field, Select, GroupField, Checkbox, DatePicker, SubmitButton } from '@components';
import { getClientes } from '@sdk/Clientes';
import { getUnidadesClienteSelect } from '@sdk/Clientes/Unidades';
import styled from 'styled-components';
import { dateToAnsi, DATE_FORMATS, moment, Notification } from '@utils';
import { useDispatch, useSelector } from 'react-redux';
import { deleteExclusaoDados, reset } from '@ducks/indicadoresExclusaoDados';

const FieldStlyed = styled(Field)`
  width: 100%;
  padding-right: 15px;
`;

const dados = [{ key: '100000', value: '100000', title: 'Vendas' }];

export default function ExclusaoDados() {
  const [form] = FormCadastro.useForm();
  const [idCliente, setIdCliente] = useState(-1);
  const [todasUnidades, setTodasUnidades] = useState(true);
  const dispatch = useDispatch();
  const dateRef = useRef(null);

  const successDeleteDados = useSelector(({ indicadoresExclusaoDados }) => indicadoresExclusaoDados.get('successDeleteDados'));

  useEffect(() => {
    if (successDeleteDados) {
      dispatch(reset());
      resetForm();
      Notification.success('Dados excluídos');
      if (dateRef && dateRef.current) dateRef.current.focus();
    }
  }, [successDeleteDados]);

  const getDados = async () => {
    return dados;
  };

  const resetForm = () => {
    setIdCliente(-1);
    setTodasUnidades(true);
    form.setFieldsValue({ idCliente: undefined, periodo: [], dados: dados[0].key, todasUnidades: true, unidades: undefined });
  };

  const handleOnChangeCliente = (idCliente) => {
    setIdCliente(-1);
    setTodasUnidades(true);
    form.setFieldsValue({ todasUnidades: true, unidades: undefined });
    setTimeout(() => setIdCliente(idCliente), 2);
  };

  const handleSubmit = (data) => {
    data.dtInicio = dateToAnsi(data.periodo[0], DATE_FORMATS.ANSI_DATE, DATE_FORMATS.ANSI_DATE);
    data.dtFim = dateToAnsi(data.periodo[1], DATE_FORMATS.ANSI_DATE, DATE_FORMATS.ANSI_DATE);
    delete data.periodo;
    dispatch(deleteExclusaoDados(data));
  };

  return (
    <App>
      <Body>
        <PageHeader title='Exclusão de Dados'>
          <FormCadastro form={form} hideRequiredMark onFinish={handleSubmit}>
            <GroupField>
              <FieldStlyed label='Dado' name='idDado' rules={[{ required: true, message: 'Informe o dado' }]}>
                <Select form={form} allowClear={false} name='idDado' action={() => getDados()} placeholder='Selecione um dado' />
              </FieldStlyed>
              <FieldStlyed label='Período' name='periodo' rules={[{ required: true, message: 'Informe o período' }]}>
                <DatePicker.RangePicker
                  ref={dateRef}
                  autoFocus
                  format='DD/MM/YYYY'
                  ranges={{
                    Hoje: [moment(), moment()],
                    Ontem: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                    'Esse mês': [moment().startOf('month'), moment().endOf('month')],
                    'Mês passado': [moment().subtract(1, 'months').startOf('month'), moment().subtract(1, 'months').endOf('month')],
                  }}
                />
              </FieldStlyed>
            </GroupField>
            <GroupField>
              <FieldStlyed label='Cliente' name='idCliente' rules={[{ required: true, message: 'Informe o cliente' }]}>
                <Select
                  form={form}
                  id='idCliente'
                  name='idCliente'
                  action={() => getClientes()}
                  placeholder='Selecione um cliente'
                  onChange={(value) => handleOnChangeCliente(value)}
                  autoFocus
                />
              </FieldStlyed>
              {idCliente !== -1 && !todasUnidades && (
                <FieldStlyed label='Unidades' name='unidades' rules={[{ required: true, message: 'Selecione ao menos uma unidade' }]}>
                  <Select
                    mode='multiple'
                    form={form}
                    id='unidades'
                    name='unidades'
                    action={() => getUnidadesClienteSelect(idCliente)}
                    placeholder='Selecione as unidades'
                  />
                </FieldStlyed>
              )}
            </GroupField>
            {idCliente !== -1 && (
              <FieldStlyed name='todasUnidades' valuePropName='checked'>
                <Checkbox onChange={(value) => setTodasUnidades(value.target.checked)}> Todas as unidades </Checkbox>
              </FieldStlyed>
            )}

            <SubmitButton type='danger' htmlType='submit'>
              Excluir dados
            </SubmitButton>
          </FormCadastro>
        </PageHeader>
      </Body>
    </App>
  );
}
